// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__v_hzj","wrapper":"styles_wrapper___4QAs","container":"styles_container__lWOR5","navigation":"styles_navigation__cnpwB","copy":"styles_copy___O1MR"};